export const seoConfig = {
  siteName: 'Dr. Fathima Finu',
  siteUrl: 'https://fathimafinu.com',
  defaultImage: '/images/health-hero.webp',
  defaultImageAlt: 'Abstract glass heart and wellness forms in a bright studio',
}
